import { render, staticRenderFns } from "./ModalClearClinicalData.vue?vue&type=template&id=4c25b7aa&scoped=true"
import script from "./ModalClearClinicalData.vue?vue&type=script&lang=js"
export * from "./ModalClearClinicalData.vue?vue&type=script&lang=js"
import style0 from "./ModalClearClinicalData.vue?vue&type=style&index=0&id=4c25b7aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c25b7aa",
  null
  
)

export default component.exports